var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducationHistoryPlaceholder = function SvgEducationHistoryPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "m17.93 9.212-6.208-2.19a.4.4 0 0 0-.257 0l-6.207 2.19a.386.386 0 0 0-.001.729l6.207 2.206a.4.4 0 0 0 .26 0l6.207-2.206a.386.386 0 0 0-.001-.729M17.26 14.37V11l-.773.275v3.095a.776.776 0 0 0 0 1.346v1.898a.386.386 0 0 0 .772 0v-1.898a.775.775 0 0 0 0-1.346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M11.594 12.94q-.2 0-.389-.067l-3.49-1.24v1.7c0 .416.435.768 1.29 1.045.746.243 1.666.376 2.589.376s1.842-.133 2.588-.376c.856-.277 1.29-.63 1.29-1.045v-1.7l-3.49 1.24a1.2 1.2 0 0 1-.388.067"
  })));
};
export default SvgEducationHistoryPlaceholder;